var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast"}},[(_vm.visible)?_c('div',{staticClass:"toast-message",class:_vm.type},[_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }